export default __webpack_public_path__ + "static/media/header.4e66403f.jpeg";